export const DEFAULT_SITE_SETTINGS = {
  social_linkedin_enabled: true,
  social_linkedin_url: 'https://www.linkedin.com/company/luxe-jobs-london',
  social_tiktok_enabled: false,
  social_tiktok_url: '',
  social_instagram_enabled: false,
  social_instagram_url: '',
  social_x_enabled: false,
  social_x_url: '',
  whatsapp_channel_enabled: false,
  whatsapp_channel_url: '',
};

export const SOCIAL_PLATFORMS = [
  { key: 'linkedin', label: 'LinkedIn', placeholder: 'https://www.linkedin.com/company/…' },
  { key: 'tiktok', label: 'TikTok', placeholder: 'https://www.tiktok.com/@…' },
  { key: 'instagram', label: 'Instagram', placeholder: 'https://www.instagram.com/…' },
  { key: 'x', label: 'X (Twitter)', placeholder: 'https://x.com/…' },
];

export const normalizeSiteSettings = settings => ({
  ...DEFAULT_SITE_SETTINGS,
  ...(settings || {}),
});

export const isSafeSocialUrl = value => {
  try {
    const url = new URL(String(value || '').trim());
    return url.protocol === 'https:';
  } catch {
    return false;
  }
};

export const visibleSocialPlatforms = settings => {
  const normalized = normalizeSiteSettings(settings);
  return SOCIAL_PLATFORMS.filter(platform => normalized[`social_${platform.key}_enabled`] && isSafeSocialUrl(normalized[`social_${platform.key}_url`]))
    .map(platform => ({ ...platform, url: normalized[`social_${platform.key}_url`].trim() }));
};
